import React, { useCallback } from 'react'

import { Space } from '@gousto-internal/citrus-react'
import { useDispatch, useSelector } from 'react-redux'

import { trackSubmitOrderEvent } from 'actions/tracking'
import { CheckoutButton } from 'routes/Checkout/Components/CheckoutButton'
import { isSubmitting as getIsSubmitting } from 'routes/Checkout/utils/state'
import { getIsGoustoOnDemandEnabled } from 'selectors/features'

type SubmitButtonProps = {
  isDisabled: boolean
  onClick: () => void
}

export const SubmitButton = ({ isDisabled, onClick }: SubmitButtonProps) => {
  const dispatch = useDispatch()

  const isSubmitting = useSelector(getIsSubmitting)
  const isGoustoOnDemandEnabled = useSelector(getIsGoustoOnDemandEnabled)

  const handleClick = useCallback(() => {
    dispatch(trackSubmitOrderEvent())
    onClick()
  }, [dispatch, onClick])

  return (
    <>
      <CheckoutButton onClick={handleClick} isLoading={isSubmitting} isDisabled={isDisabled}>
        {isGoustoOnDemandEnabled ? 'Order your box' : 'Start your subscription'}
      </CheckoutButton>
      <Space direction="vertical" size={[4, null, 5]} />
    </>
  )
}
